import React from 'react';
import { Box, TextField, FormControlLabel, Checkbox, Alert, Typography } from '@mui/material';

import { MethodEditorProps } from '../types';

export const LoadUserEditor: React.FC<MethodEditorProps> = ({ payload, onChange }) => {
  const waitForCompletion = payload?.waitForCompletion !== false;

  return (
    <Box>
      <TextField
        fullWidth
        value={payload?.outputPath || 'user'}
        onChange={(e) => onChange({ ...payload, outputPath: e.target.value })}
        label="Output Path"
        placeholder="user"
        helperText="Context path where user data will be stored"
        margin="normal"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={waitForCompletion}
            onChange={(e) => onChange({ ...payload, waitForCompletion: e.target.checked })}
          />
        }
        label="Wait for loading to complete"
        sx={{ mt: 1, mb: 2 }}
      />

      {!waitForCompletion && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="body2">
            <strong>Warning:</strong> Loading will continue in background. Ensure subsequent steps
            include a delay or use &quot;Wait for Context&quot; method to avoid accessing incomplete
            data.
          </Typography>
        </Alert>
      )}

      <Alert severity="info" sx={{ mt: 2 }}>
        <Typography variant="body2">
          <strong>Output:</strong> User object with userName, userEmail, userId, userType, and
          organization
          <br />
          <strong>User Name:</strong> Formatted display name using displayName utility
          <br />
          <strong>Organization:</strong> Includes id, name, and type if user has organization
          <br />
          <strong>Wait Option:</strong> When unchecked, continues flow immediately while loading in
          background
        </Typography>
      </Alert>
    </Box>
  );
};
